// extracted by mini-css-extract-plugin
export default {"footer":"footer_card__footer--27f1","footerCard":"footer_card__footerCard--eH7d","footerIcons":"footer_card__footerIcons--zvLM"};